import React, { useState, useEffect } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CircularProgress, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { getData, getHeaders } from '../../http/request';
import { ENTRYPOINT, ENTRYPOINT_PUBLIC } from '../../config/entrypoint';
import { API_ROUTES } from '../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../constants/constants';

const AutocompleteField = (props) => {
    const { label, placeholder, api, isClearable, handleObject, preloadValue, multiple, parameters, disabled } = props;

    const [value, setValue] = useState(multiple ? [] : null);
    const [inputValue, setInputValue] = useState('');
	const [open, setOpen] = useState(false);
	const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;
    useEffect(() => {
        if (preloadValue) {
            (async () => {
                if (multiple && !value.length && preloadValue) {
                    let values = [];
                    for (const preload of preloadValue) {
                        const GET_URL = `${ENTRYPOINT_PUBLIC}${preload?.['@id'] || preload}`;
                        const response = await getData(GET_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
                        values = [...values, response];
                    }
                    if (values.length) {
                        setValue(values);
                        handleObject && handleObject(values);
                    }
                }
                else if (!value && preloadValue) {
                    const GET_URL = `${ENTRYPOINT_PUBLIC}${preloadValue?.['@id'] || preloadValue}`;
                    const response = await getData(GET_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
                    if (response) {
                        setValue(response);
                        handleObject && handleObject(response);
                    }
                }
            })();
        }
    }, [preloadValue]);

    const loadOptions = async (inputValue) => {
        if (inputValue) {
            let GET_URL = `${ENTRYPOINT}${api}`;
            if ([API_ROUTES.CUSTOMERS, API_ROUTES.WORKERS, API_ROUTES.USERS].includes(api)) {
                let searchParams = `?search=${inputValue}`;
                if (inputValue.split(' ').length === 2) {
                    const [firstName, lastName] = inputValue.split(' ');
                    searchParams = `?firstName=${firstName}&lastName=${lastName}`;
                }
                GET_URL = `${GET_URL}${searchParams}`;
            }
            if ([API_ROUTES.ARTICLES, API_ROUTES.AREAS, API_ROUTES.SUB_AREAS, API_ROUTES.THERAPIES, API_ROUTES.EXPENSES, API_ROUTES.EXPENSE_TYPES].includes(api)) {
                let searchParams = `?search=${inputValue}`;
                GET_URL = `${GET_URL}${searchParams}`;
            }
            if (parameters) {
                GET_URL = `${GET_URL}${parameters}`;
            }
            const response = await getData(GET_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
            setOptions(response['hydra:member']);
        }
    };

    const getOptionLabel = (option) => {
        if ([API_ROUTES.CUSTOMERS, API_ROUTES.WORKERS, API_ROUTES.USERS].includes(api)) {
            return `${option?.firstName} ${option?.lastName} ${option?.worker ? `(Radnik - ${option?.worker?.firstName} ${option?.worker?.lastName})` : ''}`;
        }
        if (api === API_ROUTES.THERAPIES) {
            return `${option?.name} (${option?.dose})`;
        }
        return option?.name || '';
    }

    const getOptionSelected = (option, value) => {
        return option.uuid === value.uuid;
    }

	return (
		<Autocomplete
            disabled={disabled}
            clearOnBlur
            includeInputInList
            forcePopupIcon={false}
            disableClearable={!!isClearable}
            value={value}
            onChange={(event, newValue) => {
                setValue(newValue);
                handleObject && handleObject(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
			open={open}
			onOpen={() => {
				setOpen(true);
			}}
			onClose={() => {
				setOpen(false);
                setOptions([]);
			}}
			getOptionLabel={getOptionLabel}
            getOptionSelected={getOptionSelected}
			options={options}
            parameters={parameters}
			loading={loading}
            loadingText={!!inputValue && options.length === 0 ? 'Nema opcija' : 'Počnite da kucate...'}
            noOptionsText="Nema opcija"
            multiple={multiple || false}
            fullWidth
			renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                    variant="standard"
                    margin="normal"
                    onChange={event => event.target.value && loadOptions(event.target.value)}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} style={{ position: 'absolute', left: '87.5%' }} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
			)}
		/>
	);
}

AutocompleteField.propTypes = {
    api: PropTypes.string.isRequired,
    input: PropTypes.object,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    InputLabelProps: PropTypes.object,
    isClearable: PropTypes.bool,
    handleObject: PropTypes.func,
    preloadValue: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
        PropTypes.array
    ]),
    multiple: PropTypes.bool,
    parameters: PropTypes.string,
    disabled: PropTypes.bool
};

export default AutocompleteField;
